import { Box } from '@rbilabs/universal-components';

export const PickerAspectGroupContainer = Box.withConfig({
  width: 'full',
});
